(() => {
  if (window.BBCollectionPagesInitialized) return;
  window.BBCollectionPagesInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.bb-category-reveal').forEach((element) => element.classList.add('is-revealed'));
    return;
  }

  document.documentElement.classList.add('bb-category-motion');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const register = (root = document) => {
    if (root.matches?.('.bb-category-reveal:not([data-bb-reveal-ready])')) {
      root.dataset.bbRevealReady = 'true';
      observer.observe(root);
    }
    root.querySelectorAll?.('.bb-category-reveal:not([data-bb-reveal-ready])').forEach((element) => {
      element.dataset.bbRevealReady = 'true';
      observer.observe(element);
    });
  };

  register();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) register(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
